// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// NETBLOCK WHOIS SCHEMA
/////////////////////////////////////////

export const NetblockWhoisSchema = z.object({
  handle: z.string().nullable(),
  name: z.string().nullable(),
  netType: z.string().nullable(),
  parentHandle: z.string().nullable(),
  netname: z.string().nullable(),
  country: z.string().nullable(),
  registry: z.string().nullable(),
  asn: z.string().nullable(),
  registeredCidr: z.string().nullable(),
  status: z.string().array(),
  fetchedAt: z.coerce.date().nullable(),
})

export type NetblockWhois = z.infer<typeof NetblockWhoisSchema>

export default NetblockWhoisSchema;
